// Module
var code = "<h5>Profile - Security</h5>\r\n<hr/>\r\n";
// Exports
module.exports = code;